<template>
  <div id="app">
    <p class="top-title">2019年9月30日10:00:00-10月7日23:59:59</p>
    <p class="login">
      {{username}}
      <span @click="open('login')" v-if="!isLogin">登录</span>
      <span @click="handleLogout" class="logout" v-else>注销</span>
    </p>
    <Signin :loginStatus="isLogin" />
    <Partone />
    <TaskDraw :loginStatus="isLogin" :drawTimes="drawTimes" @get-prize="handleControl" />
    <Rule />
    <Login :show="openLogin" @cancle-login="open('login')" @get-msg="LoginSuccess" />
    <p class="bottom">
      <i class="qq"></i> 官方客服Q群：601299812
    </p>
    <!-- 弹窗 -->
    <PrizeList :show="openPrizeList" @handle-get="handleToGetSW" />
    <GetSW :show="openGet" :msg="draw" />
    <MsgAlert :show="openAlert" :msg="draw" @change-alert="handleToGetSW" />
    <ShowGames :show="openShowGames" :prize="draw" :from="DjqType" />
  </div>
</template>

<script>
import Signin from "./components/Signin.vue";
import Partone from "./components/Partone.vue";
import TaskDraw from "./components/TaskDraw.vue";
import Rule from "./components/Rule.vue";
import Login from "./components/Login.vue";
import PrizeList from "./components/PrizeList.vue";
import GetSW from "./components/GetSW.vue";
import MsgAlert from "./components/MsgAlert.vue";
import ShowGames from "./components/ShowGames.vue";
export default {
  name: "app",
  components: {
    Signin,
    Partone,
    TaskDraw,
    Rule,
    Login,
    PrizeList,
    GetSW,
    MsgAlert,
    ShowGames
  },
  data: () => ({
    openLogin: false,
    openPrizeList: false,
    openGet: false,
    openAlert: false,
    openShowGames: false,
    isLogin: false, //判断是否登录
    username: "", //用户名
    drawTimes: 0, //抽奖次数
    draw: {}, //中奖礼物
    DjqType: "draw"
  }),
  async created() {
    //先获取url上的uid和token进行登录
    let urlParams = {
      uid: this.getParam("uid"),
      token: this.getParam("token")
    };
    let { data: loginDes } = await this.$api.activity.login(urlParams);
    if (loginDes.code === 0) {
      this.LoginSuccess(loginDes.data);
      return;
    }
    //当没有uid和token说明不在雷电圈内，然后判断是否在网页登录过
    this.handleIsLogin();
  },
  methods: {
    open(type) {
      switch (type) {
        //登录弹窗
        case "login":
          this.openLogin = !this.openLogin;
          break;
        //奖品列表弹窗
        case "prizeList":
          this.openPrizeList = !this.openPrizeList;
          break;
        //填取领奖信息弹窗
        case "getSW":
          this.openGet = !this.openGet;
          break;
        case "msgAlert":
          this.openAlert = !this.openAlert;
          break;
        case "showGames":
          this.openShowGames = !this.openShowGames;
          break;
        default:
          break;
      }
    },
    // 获取url的参数
    getParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    //登录成功的初始化状态
    LoginSuccess(obj) {
      this.username = obj.username;
      this.drawTimes = obj.drawTimes;
      this.isLogin = true;
    },
    // 登录失败的状态或者注销登录
    LoginFail() {
      this.username = "";
      this.isLogin = false;
      this.drawTimes = 0;
    },
    async handleIsLogin() {
      let { data } = await this.$api.activity.isLogin();
      if (data.code === 0) {
        this.LoginSuccess(data.data);
      } else {
        this.$toast({
          message: "请登录",
          duration: 1200,
          position: "bottom"
        });
        this.LoginFail();
      }
    },
    //注销登录
    async handleLogout() {
      let { data } = await this.$api.activity.logout();
      if (data.code === 0) {
        this.$toast({
          type: "success",
          message: "登出成功",
          duration: 1200,
          position: "middle"
        });
        this.LoginFail();
      }
    },
    //转盘转动完之后操作
    handleControl(obj) {
      this.draw = obj;
      this.open("msgAlert");
    },
    //抽奖之后跳转填写信息弹窗
    handleToGetSW(item = null) {
      if (item) {
        this.draw = item;
      }
      if (this.draw.type === "LB" || this.draw.type === "DDY") return;
      if (this.draw.property1) {
        let reg = /^[0-9]*$/g;
        let text = this.draw.property1.replace(/\s/g, "");
        if (reg.test(text)) {
          return;
        }
      }
      if (this.draw.type === "DJQ") {
        this.DjqType = "draw";
        this.open("showGames");
        return;
      }
      this.open("getSW");
    }
  }
};
</script>

<style lang="scss">
#app {
  height: 100%;
  max-width: 582px;
  box-sizing: border-box;
  margin: 0 auto;
  background: url("./assets/bg-min2.jpg") no-repeat;
  background-size: 100% 100%;
  padding: 350px 0 60px;
  text-align: center;
  font-size: 12px;
  .top-title {
    display: inline-block;
    padding: 8px 20px;
    margin-bottom: 60px;
    font-size: 24px;
    color: #461e01;
    background-image: url("./assets/kuang-min.png");
    background-size: 100% 100%;
  }
  .login {
    font-size: 30px;
    color: #461e01;
    text-align: center;
    margin-bottom: 535px;
    span {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .logout {
    color: #de6c0a;
  }
  .bottom {
    padding-top: 240px;
    text-align: center;
    font-size: 26px;
    color: #a8621e;
    display: flex;
    align-items: center;
    justify-content: center;
    .qq {
      display: block;
      margin-right: 10px;
      width: 36px;
      height: 40px;
      background-image: url("./assets/qq-min.png");
      background-size: 100% 100%;
    }
  }
}
</style>
